<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    v-model="showImageGallery"
    width="1000"
  >
    <v-layout
      align-start
      v-if="showImageGallery && images.length > 0"
      justify-start
      style="background: #263238; "
      column
      fill-height
    >
      <div style="width: 100%; color: white; padding: 15px;">
        <v-layout align-center justify-start color="gray" row>
          <h4>{{ images[currentImageIndex].attributes.tittel }}</h4>
          <v-spacer />
          <v-btn
            v-if="$vuetify.breakpoint.mdAndUp"
            flat
            dark
            color="blue"
            :href="images[currentImageIndex].attributes.infoUrl"            
            >Åpne i fotostrømmen</v-btn
          >
          <v-btn @click="close" fab small dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </div>
      <div style="background: #5f5f5f; width: 100%; color: white" class="pa-3">
        {{
          images[currentImageIndex].attributes.beskrivelse == "Null"
            ? "Ingen beskrivelse"
            : images[currentImageIndex].attributes.beskrivelse
        }}
        ({{ getPhotoDateText(images[currentImageIndex]) }},
        {{ images[currentImageIndex].attributes.fotograf }})
      </div>
      <v-carousel
        :hide-delimiters="images.length == 1"
        :hide-controls="images.length == 1"
        v-model="currentImageIndex"
        :cycle="false"
      >
        <v-carousel-item
          contain
          lazy
          v-for="(item, i) in images"
          :src="imageProxyUrl + item.attributes.webUrl"
          :key="i"
        >
        </v-carousel-item>
      </v-carousel>
    </v-layout>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Vue from "vue";
import { loadModules } from "esri-loader";
export default {
  name: "ImageGallery",
  data: function() {
    return {
      loading: true,
      currentImageIndex: 0,
      images: []
    };
  },
  props: {
    layer: Object,
    open: Boolean
  },
  watch: {
    showImageGallery(newVal) {
      if (newVal) {
        this.getAllImagesFromPoint(
          this.imageGalleryItems[0].geometry.x,
          this.imageGalleryItems[0].geometry.y
        );
      }
    }
  },
  computed: {
    ...mapState(["imageGalleryItems", "is3d", "isConnectedToIntranet"]),
    imageProxyUrl: function() {
      return this.isConnectedToIntranet
        ? process.env.VUE_APP_INTERNAL_PROXY_URL
        : process.env.VUE_APP_PROXY_URL;
    },
    showImageGallery: {
      set(showImageGallery) {
        this.setShowImageGallery(showImageGallery);
      },
      get() {
        return this.$store.state.showImageGallery;
      }
    }
  },
  methods: {
    ...mapActions(["setShowImageGallery"]),
    close: function() {
      this.currentImageIndex = 0;
      this.showImageGallery = false;
    },
    getPhotoDateText: function(photo) {
      return photo.attributes.dato
        ? Vue.moment.unix(photo.attributes.dato / 1000).format("DD.MM.YYYY")
        : "Ingen dato";
    },
    getAllImagesFromPoint: function(x, y) {
      loadModules(["esri/geometry/Point"]).then(([Point]) => {
        this.images = [];
        let photolayer = this.$theMapObject.findLayerById("foto");

        let currentView = this.is3d
          ? this.$theSceneViewObject
          : this.$theMapViewObject;

        let distance =
          currentView.zoom < 10
            ? currentView.zoom < 7
              ? currentView.zoom < 5
                ? currentView.zoom < 3
                  ? 5000
                  : 2000
                : 1000
              : 200
            : 20;

        photolayer
          .queryFeatures({
            geometry: new Point({
              x: x,
              y: y,
              spatialReference: { wkid: 25833 }
            }),
            where: photolayer.definitionExpression,
            distance: distance,
            units: "meters",
            spatialRelationship: "intersects",
            returnGeometry: false,
            outFields: ["*"]
          })
          .then(featureSet => {
            this.images = featureSet.features;
          });
      });
    }
  },
  mounted() {}
};
</script>

<style></style>
